<template>
  <div class="content">
<!--    <p style="color:red;font-size:20px">-->
<!--      <b>中国教师资格网<br>教师资格认定及定期注册照片处理辅助工具</b>-->
<!--    </p>-->
    <p class="title"> <b>照片处理辅助工具</b> </p>



    <div style="display: flex;justify-content: center">

<!--      <div style="width: 500px;text-align: left;margin-right: 10px">-->
<!--        <p style=" font-size:16px">教师资格认定或定期注册报名所使用的照片要求：<br><br>-->
<!--          1.照片应上传本人近期一寸白底正面免冠证件照。<br>-->
<!--          2.图片应为jpg格式，<font color="red">文件应小于190kb，并在此基础上尽量保证清晰。</font><br>-->
<!--          3.照片文件<font color="red">宽度（水平像素）设置在290到300之间，高度（垂直像素）应在408到418之间。</font><br>-->
<!--          4.人像比例参照示例图，<font color="red">照片中人像的位置要居中。</font>-->
<!--        </p>-->

<!--        <p style="color:red;font-size:16px">-->
<!--          照片处理说明：<br>-->
<!--          1:点击【选择照片】后，右侧将展示所选照片，拖动裁剪框，将人像置于裁剪框中间位置，右侧将展示裁剪后的照片预览，确认无误可点击【下载】将裁剪后的照片下载至浏览器默认存储位置。<br>-->
<!--          2:人像比例参照示例图，且照片中人像位置需居中，人像头顶上方可部分留白，需裁剪出人像的脖子、肩膀。<br>-->
<!--          3:裁剪的照片尺寸为295*413，且自动保存为jpg格式，可直接用于教师资格认定或定期注册报名。<br>-->
<!--          4:本工具不支持照片背景颜色的更换，请自行处理：<br>-->
<!--          5:本工具在“中国教师资格网”的“咨询服务”栏目下，常见问题15描述中可使用。<br>-->
<!--        </p>-->
<!--      </div>-->

      <cropper-image
        :Name="cropperName"
        @uploadImgSuccess = "handleUploadSuccess"
        ref="child">
      </cropper-image>

    </div>
  </div>
</template>

<script>
import CropperImage from "./CropperComponent.vue";
export default {
  name: "Tailoring",
  components: {
    CropperImage
  },
  data () {
    return {
            ruleValidate: {
              mainImage: [
                {required: true, message: '请上传封面', trigger: 'blur'}
              ],
            },
            //裁切图片参数
            cropperName:'',
            imgName: '',
            imgVisible: false
    }
  },

  methods: {

      //图片上传成功后
      handleUploadSuccess (data){
        console.log(data)
      }

  }
}
</script>

<style scoped>
.title{
  font-size:24px
}
.content{
  /*padding-top: 60px;*/
  padding-top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/index3.vue